import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('flow');
const type = createActionType('flow');

export const SET_DEFAULT_FLOW_MODE = type('setDefaultFlowMode');

export const TOGGLE_SELECTION = type('ToggleSelection');
export const FROM_TO_SELECTION = type('FromToSelection');
export const AREA_SELECTION = type('AreaSelection');
export const CLEAR_SELECTION = type('ClearSelection');

export const CREATE_NODE_GROUP = apiType('CreateNodeGroup');
export const DELETE_NODE_GROUP = apiType('DeleteNodeGroup');
export const RENAME_NODE_GROUP = apiType('RenameNodeGroup');
export const UPDATE_NODE_GROUP_DESCRIPTION = apiType('UpdateNodeGroupDescription');

export const TOGGLE_GROUP = type('ToggleGroup');
export const SET_BULK_GROUP_EXPANSION = type('SetBulkGroupExpansion');
export const EXPAND_ALL_GROUPS = type('ExpandAllGroups');
export const COLLAPSE_ALL_GROUPS = type('CollapseAllGroups');

export const NAVIGATE_TO_NODE = type('NavigateToNode');
